import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../Dropdown'
import {
    SidebarDialogue,
    SidebarDialogueViewProps,
    SidebarDialoguesViewProps,
} from './types'
import {
    styledButton,
    styledContent,
    styledGroup,
    styledList,
    styledName,
} from 'components/Sidebar/styles'
import Button from '../Button'
import React from 'react'
import UserAvatar from '../Avatar/UserAvatar'
import {styled} from 'stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useTranslation} from 'react-i18next'
import {useUserDetails} from 'hooks/ninchat'

const StyledGroup = styled('ul', styledGroup)
const StyledList = styled('li', styledList)
const StyledContent = styled('div', styledContent)
const StyledButton = styled('button', styledButton)
const StyledName = styled('div', styledName)

const StyledItem = styled('div', styledItem)

const SidebarDialogueView = ({
    loadDialogue,
    dialogue_id,
    dialogue_status,
    onHide,
}: SidebarDialogueViewProps): React.ReactElement => {
    const {t} = useTranslation()

    const dialogueUserDetails = useUserDetails({
        dialogueStatus: dialogue_status,
        userId: dialogue_id,
    })

    return (
        <StyledList key={dialogue_id}>
            <StyledContent>
                <StyledButton
                    active={dialogueUserDetails.isSelected}
                    onClick={() => loadDialogue(dialogue_id)}
                    type='button'
                >
                    <UserAvatar
                        connected={dialogueUserDetails.connected}
                        highlight={dialogueUserDetails.dialogueStatus === 'highlight'}
                        idle={Boolean(dialogueUserDetails.idle)}
                        name={dialogueUserDetails.name}
                        size='small'
                        src={dialogueUserDetails.iconurl}
                        unread={dialogueUserDetails.dialogueStatus === 'unread'}
                    />
                    <StyledName status={dialogueUserDetails.dialogueStatus}>{dialogueUserDetails.name}</StyledName>
                </StyledButton>
                <Dropdown>
                    <DropdownButton caret={true} color='text' data-id='dropdown-caret' size='small' />
                    <DropdownContent direction='fixed-end'>
                        <StyledItem>
                            <Button
                                color='text'
                                onPress={(): void => onHide(dialogue_id)}
                                text={t('Hide conversation')}
                                title={t('Hide conversation')}
                                type='button'
                            />
                        </StyledItem>
                    </DropdownContent>
                </Dropdown>
            </StyledContent>
        </StyledList>
    )
}


export const SidebarDialoguesView = ({
    dialogues, loadDialogue, onHide,
}: SidebarDialoguesViewProps): React.ReactElement => {
    const {t} = useTranslation()
    return (
        <>
            {dialogues?.length > 0 &&
            <StyledGroup aria-label={t('Dialogues')}>
                {dialogues.map(({
                    dialogue_id, dialogue_status,
                }: SidebarDialogue) => (
                    <SidebarDialogueView
                        dialogue_id={dialogue_id}
                        dialogue_status={dialogue_status}
                        key={dialogue_id}
                        loadDialogue={loadDialogue}
                        onHide={onHide}
                    />))}
            </StyledGroup>}
            {}
        </>
    )
}
